let list = [];
let all = 0;
list.forEach(function(item){
    all += item.value;
})

let colorList = ['#FFC67E', '#5DB7D2', '#BF8AF2', '#FF945E', '#1773DD', '#61D79B'];

export const echartTemp  = [
  {
    tooltip: {
      trigger: 'item'
    },
    title: {
      text: all,
      subtext: '',
      x: '19%',
      y: 'center',
      textAlign: 'center',
      textVerticalAlign: 'middle',
      itemGap: 5,
      textStyle: {
        fontSize: 50,
        fontWeight: 'normal',
        color: '#333',
      },
      subtextStyle: {
        fontSize: 20,
        fontWeight: 'normal',
        align: 'center',
        color: '#555',
      },
    },
    legend: {
      orient: 'vertical',
      right: '5%',
      align: 'left',
      top: 'middle',
      itemWidth: 13,
      itemHeight: 13,
      icon: 'circle',
      itemGap: 10,
      data: list,
      show: true,
      formatter: function (name) {
        // console.log('name--', name);
        // let data = 0
        var res = '';
        for (var i = 0; i < list.length; i++) {
          if (list[i].name == name) {
            res += '{a|' + name + '}'+ '{b|' + list[i].value + '}';
          }
        }
        return res;
      },
      textStyle: {
        color: '#000',
        rich: {
          a: {
            fontSize: 14,
            color: '#666',
            padding: [0, 10, 0, 6],
          },
          b: {
            fontSize: 14,
            color: '#666',
            padding: [0, 6, 0, 6],
          },
        },
      },
    },
    series: [
      {
        type: 'pie',
        radius: ['45%', '60%'],
        center: ['20%', '50%'],
        color: colorList,
        itemStyle: {
          normal: {
            borderWidth: 0,
            borderColor: '#fff',
          }
        },
        data: list,
        labelLine: {
          normal: {
            show: false,
          },
        },
        label: {
          show: false,
        },
      },
      // 边框的设置
      {
        radius: ['57%', '61%'],
        center: ['20%', '50%'],
        type: 'pie',
        label: {
          normal: {
            show: false
          },
          emphasis: {
            show: false
          }
        },
        labelLine: {
          normal: {
            show: false
          },
          emphasis: {
            show: false
          }
        },
        animation: false,
        tooltip: {
          show: false
        },
        itemStyle: {
          normal: {
            color:'rgba(250,250,250,0.5)'
          }
        },
        data: [{
          value: 1,
        }],
      }
    ],
  },
];